import { Button } from './Button'
import {
  Dialog as MUIDialog,
  DialogActions,
  DialogContent,
  DialogContentText,
  DialogTitle,
} from '@mui/material'
import { DialogProps } from './Dialog.types'

export const Dialog = ({
  title,
  content,
  primaryButtonLabel,
  secondaryButtonLabel,
  open,
  handleClose,
  handlePrimaryButtonClick,
  handleSecondaryButtonClick,
}: DialogProps) => {
  return (
    <div>
      <MUIDialog
        open={open}
        onClose={handleClose}
        aria-labelledby="dialog-title"
        aria-describedby="dialog-description"
      >
        <DialogTitle id="dialog-title">{title}</DialogTitle>
        <DialogContent>
          <DialogContentText id="dialog-description">
            {content}
          </DialogContentText>
        </DialogContent>
        <DialogActions>
          {!!secondaryButtonLabel && (
            <Button
              variant="outlined"
              size="small"
              onClick={handleSecondaryButtonClick}
            >
              {secondaryButtonLabel}
            </Button>
          )}
          <Button
            color="primary"
            variant="contained"
            size="small"
            onClick={handlePrimaryButtonClick}
          >
            {primaryButtonLabel}
          </Button>
        </DialogActions>
      </MUIDialog>
    </div>
  )
}
